import { connect } from 'react-redux';

import {
  getFilteredFunnels,
  getFunnelFilterValue,
  getFunnels,
  getFunnelSideListContainerWidth,
  getMyPermissions,
  getSelectedFunnel,
} from '../../../reducers/analyticsApp';
import {
  deleteFunnel,
  duplicateFunnel,
  selectFunnel,
  setFunnelFilterValue,
  setFunnelSideListContainerWidth,
  startUpdateFunnel,
} from '../../../actions/funnel';
import CompoundSideListItems from '../../../components/compound/side/ListItems';
import { staticPermissions } from '../../../constants/authorization';
import docsBookmarks from '../../../constants/docs';

const mapStateToProps = (state) => ({
  funnels: getFunnels(state),
  items: getFilteredFunnels(state),
  searchedItem: getFunnelFilterValue(state),
  selectedItem: getSelectedFunnel(state),
  hasPermission: getMyPermissions(state).has(staticPermissions.FUNNEL_MANAGE),
  containerWidth: getFunnelSideListContainerWidth(state),
  scrolTo: docsBookmarks.funnels,
});

const mapDispatchToProps = (dispatch, { navigate, tenantId }) => ({
  onSearch: (value) => dispatch(setFunnelFilterValue(value)),
  onPreview: (item) => {
    dispatch(selectFunnel(item));
    navigate(`/${tenantId}/funnels/execution/${item.id}`);
  },
  onDelete: (item) => {
    dispatch(deleteFunnel(item.id));
  },
  onUpdate: (item) => {
    dispatch(startUpdateFunnel(item));
    navigate(`/${tenantId}/funnels/update/${item.id}`);
  },
  setContainerWidth: (width) => dispatch(setFunnelSideListContainerWidth(width)),
  onDuplicate: (item) => {
    dispatch(duplicateFunnel(item));
    navigate(`/${tenantId}/funnels/add`);
  },
  showExposureSQLButton: true,
});

export default connect(mapStateToProps, mapDispatchToProps)(CompoundSideListItems);
